const mapping: Record<string, string> = {
  id: 'l=>l.Id',
  xPosition: 'p=>p.XPosition',
  yPosition: 'p=>p.YPosition',
  deviceType: 'p=>p.DeviceType',
}

export const mapSortItemParam = (key: string) => mapping[key]
